module.exports = __webpack_public_path__ + "static/banff-15f5a65a1554c033d604228e0d52b3f3.jpg";